export default __webpack_public_path__ + "static/media/dark-folder.92ada6a9.png";